//Niet als RequireJS module in verband met zichtbaarheid van ga voor require.js
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');

var id = 'UA-37811875';
	
if (document.domain == 'vgst.nl')
	id += '-1';

var userId = (function () { 
	var metas = document.getElementsByTagName('meta'); 
	for (i=0; i<metas.length; i++) { 
		if (metas[i].getAttribute('name') == 'userid') { 
			return metas[i].getAttribute('content'); 
		} 
	} 
	return '';
})();

if (userId!=0)
	ga('create', id, {
		'userId': userId,
		'cookieDomain': document.domain
	});
else
	ga('create', id, {
		'cookieDomain': document.domain
	});
	
ga('require', 'displayfeatures');
ga('send', 'pageview');
define("utils/analytics", function(){});

